/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import GaugeChart from "react-gauge-chart";
import GaugeComponent from "react-gauge-component";
import PropTypes from "prop-types";

const DialGuege = ({ data, apiData }) => {
  const ref = useRef({});
  const {
    chartTitle,
    min = 0,
    max = 100,
    isTitleHidden,
    dialType,
    startColor = "#00ff00",
    endColor = "#ff0000",
    unit: formInputUnit,
    subArcs = [
      { color: "#00ff00", limit: 35, showTick: true },
      { color: "#FFFF00", limit: 70, showTick: true },
      { color: "#ff0000", limit: 100, showTick: true },
    ],
  } = data;

  const dial = apiData?.data || {};
  // const unit = apiData?.unit || data.unit || "";

  const [ticks, setTicks] = useState([]);
  const [height, setHeight] = useState(250);

  useEffect(() => {
    if (ref.current?.clientHeight) {
      const currentHeight = ref.current.clientHeight - 50;
      setHeight(currentHeight);
    }
  }, [ref.current?.clientHeight, data.isTitleHidden]);

  useEffect(() => {
    let newValue = Number(dial?.value) || 0;
    let newMax = Math.max(newValue, max);
    let newMin = Math.min(newValue, min);

    const tickRange = [{ value: newMin }];
    const tickIncreaser = newMax / 10;
    let i = newMin + tickIncreaser;

    while (i <= newMax) {
      tickRange.push({ value: i });
      i += tickIncreaser;
    }
    setTicks(tickRange);
  }, [dial.value, min, max]);

  let newValue = Number(dial?.value) || 0;
  let newMax = Math.max(newValue, max || 100);
  let newMin = Math.min(newValue, min || 0);

  const chartTypeProps = {
    custom: {
      nrOfLevels: 30,
    },
    levels: {
      nrOfLevels: 20,
    },
    props: { id: "gauge-chart1" },
  };

  const chartType = {
    gradient: {
      type: "semicircle",
      arc: { width: 0.2, gradient: true, subArcs: [{ color: startColor }, { color: endColor }] },
    },
    simple: {
      type: "grafana",
      arc: { width: 0.2 },
    },
    temperature: {
      type: "semicircle",
      arc: { width: 0.2, padding: 0.005, cornerRadius: 1 },
    },
    default: {
      type: "grafana",
      arc: { width: 0.2 },
    },
  };

  const cleanSubArcs = (subArcs || [])
    .filter((arc) => typeof arc.limit === "number" && !isNaN(arc.limit))
    .sort((a, b) => a.limit - b.limit)
    .reduce((acc, curr) => {
      // Ensure strictly increasing limits
      if (acc.length === 0 || curr.limit > acc[acc.length - 1].limit) {
        acc.push(curr);
      } else {
        // Optionally adjust duplicates
        const lastLimit = acc[acc.length - 1].limit;
        if (lastLimit + 1 <= max && lastLimit >= min) {
          acc.push({ ...curr, limit: lastLimit + 1 });
        }
      }
      return acc;
    }, []);

  return (
    <div className="d-flex flex-column p-2 h-100 w-100" ref={ref}>
      {!isTitleHidden && (
        <div className="ql">
          <div className="ql-editor p-0 pb-1" style={{ textAlign: "center" }}>
            <div dangerouslySetInnerHTML={{ __html: chartTitle }}></div>
          </div>
        </div>
      )}
      <div className="flex-1 d-flex flex-column align-items-center justify-content-center" style={{ height }} key={height}>
        {["default", "simple", "gradient", "temperature"].includes(dialType) ? (
          <GaugeComponent
            type={chartType[dialType]?.type}
            pointer={{ type: "arrow", elastic: true }}
            arc={{ ...chartType[dialType]?.arc, subArcs: cleanSubArcs }}
            value={calculatePercentage(newMin, newMax, newValue) * 100}
            className="remove_svg-text"
          />
        ) : (
          <GaugeChart
            {...chartTypeProps[dialType || "props"]}
            percent={calculatePercentage(newMin, newMax, newValue)}
            colors={[startColor, endColor]}
            arcWidth={0.1}
            hideText={true}
          />
        )}

        <h2 className="text-center">
          {newValue.toFixed(2)} {formInputUnit && `(${formInputUnit})`}
        </h2>
      </div>
    </div>
  );
};

export default DialGuege;

function calculatePercentage(minValue, maxValue, value) {
  const percentage = (Number(value) - Number(minValue)) / (Number(maxValue) - Number(minValue));
  return percentage || 0;
}

DialGuege.propTypes = {
  data: PropTypes.object.isRequired,
  mainDashboard: PropTypes.bool,
  apiData: PropTypes.object,
};
